import { AuthorizationTokens } from "../../../types";
import {
  getFromLocalStorage,
  LocalStorageKeys,
  removeFromLocalStorage,
  setToLocalStorage,
} from "../../utils/localStorage";
import { parseJWT } from "../../utils";
import { authorization, bearer, emitterId } from "../config";
import instance from "../api";

export function setAxiosToken(accessToken: string, tokenType = bearer) {
  if (accessToken) {
    instance.defaults.headers.common[authorization] = accessToken ? `${tokenType} ${accessToken}` : "";
  }
}

export function saveTokens({ accessToken, refreshToken, expireIn }: AuthorizationTokens, isTester = false) {
  setToLocalStorage(LocalStorageKeys.accessToken, accessToken);
  setToLocalStorage(LocalStorageKeys.refreshToken, refreshToken);

  const calculatedExpireIn = expireIn - 20;
  const delay = calculatedExpireIn < 0 ? 0 : calculatedExpireIn;
  const millisecondsDelay = delay * 1000;
  const timestampDelay = Date.now() + millisecondsDelay;

  setToLocalStorage(LocalStorageKeys.expireIn, String(timestampDelay));

  setAxiosToken(accessToken);

  if (isTester) {
    setToLocalStorage(LocalStorageKeys.isTester, "true");
  } else {
    removeFromLocalStorage(LocalStorageKeys.isTester);
  }
}

export function isUserGhost(accessToken: string) {
  return parseJWT(accessToken)?.authorities[0] === "ROLE_GHOST";
}

export function isUserHost(accessToken: string) {
  return parseJWT(accessToken)?.authorities[0] === "ROLE_HOST";
}

export function isAccessTokenExpired() {
  const { accessToken, expireIn } = getTokens();

  return !accessToken || expireIn - Date.now() < 0;
}

export function removeUser() {
  const { accessToken, refreshToken } = getTokens();
  if (accessToken || refreshToken) {
    localStorage.clear();
  }

  instance.defaults.headers.common[authorization] = "";
}

export function getTokens(): AuthorizationTokens {
  return {
    accessToken: getFromLocalStorage(LocalStorageKeys.accessToken),
    refreshToken: getFromLocalStorage(LocalStorageKeys.refreshToken),
    expireIn: Number(getFromLocalStorage(LocalStorageKeys.expireIn)),
  };
}

export function setTokenForRefresh() {
  const { refreshToken } = getTokens();
  instance.defaults.headers.common[authorization] = `${bearer} ${refreshToken}`;
}

export function setEmitterIdHeader(id: number) {
  instance.defaults.headers.common[emitterId] = String(id);
}

export function removeEmitterIdHeader() {
  delete instance.defaults.headers.common[emitterId];
}
